export default __webpack_public_path__ + "static/media/tennt.eaa07dc1.png";